import Column from '@components/Column';
import Image from '@components/Image';
import Stepper from '@components/Stepper';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import usePriceUnit from '@hooks/item/usePriceUnit';
import { GiftItemRow } from '@models/gift';

interface Props {
    giftItem: GiftItemRow;
    qty: number;
    onQtyChange: (qty: number) => void;
}

function ItemInfo({ giftItem, qty, onQtyChange }: Props) {
    const { name, imageUrl, salePrice } = giftItem;
    const priceUnit = usePriceUnit();

    return (
        <Card>
            <Thumb src={imageUrl} width={84} height={60} alt={name} />
            <Meta>
                <Text size='title' fontWeight='bold' ellipsis>
                    {name}
                </Text>
                <Text size='body-short'>
                    {salePrice.toLocaleString()}{priceUnit}
                </Text>
            </Meta>
            <Stepper value={qty} size='sm' min={1} max={20}
                increase={() => onQtyChange(qty + 1)}
                decrease={() => onQtyChange(qty - 1)} />
        </Card>
    );
}

const Card = styled.div`
    display: flex;
    width: 100%;
    gap: var(--spacing-4);
    align-items: center;
    padding: var(--spacing-4);
    background: ${colors.white};
`;

const Thumb = styled(Image)`
    flex-shrink: 0;
    border-radius: 8px;
    object-fit: cover;
`;

const Meta = styled(Column)`
    flex: 1;
    min-width: 0;
    gap: var(--spacing-1);
`;

export default ItemInfo;
